import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Spinner } from "@kui-react/spinner";
import agent from "server";
import { LOCALSTORAGE_ACTIVE_ORG_ID_KEY } from "constants/index";
import { useKas } from "contexts/KasContext";
import { UserContext } from "contexts/UserContext";

const AcceptInvite: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const userContext = useContext(UserContext);
  const {
    isUserLoggedIn: kasIsAuthenticated,
    starfleetIdToken: kasStarfleetIdToken,
    user: kasUser,
  } = useKas();

  const inviteParam = new URLSearchParams(location.search).get("inviteId");

  // If no inviteId, redirect to default app route
  useEffect(() => {
    if (!inviteParam) {
      history.push("/");
    }
  }, [inviteParam, history]);

  useEffect(() => {
    if (inviteParam && kasIsAuthenticated && kasStarfleetIdToken && kasUser) {
      handleInvite(inviteParam);
    }
  }, [kasIsAuthenticated, kasStarfleetIdToken, kasUser, userContext.me]);

  const handleInvite = async (inviteId: string) => {
    const res = await agent.Invites.accept(inviteId);
    if (!res.success || !res.data?.organizationId) {
      console.error(res.message);
      history.push("/");
      return;
    }

    window.localStorage.setItem(
      LOCALSTORAGE_ACTIVE_ORG_ID_KEY,
      res.data.organizationId
    );
    history.push(`/org/${res.data.organizationId}/environments`);
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Spinner
        className="text-gray-700 dark:text-secondary"
        description="Processing invitation"
      />
    </div>
  );
};

export default AcceptInvite;
